import React from 'react';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';
import TechBadge from './ui/TechBadge';

function Expertise() {
  const categories = Object.entries(setup.skills);

  return (
    <MotionSection id="skills" muted>
      <SectionHeader
        eyebrow="Stack"
        title="Skills"
        subtitle="Technologies and tools across the full stack."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {categories.map(([category, skills], index) => (
          <motion.div
            key={category}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
            className="ui-card p-5"
          >
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-muted mb-4">
              {category}
            </h3>
            <div className="flex flex-wrap gap-2">
              {skills.map((skill) => (
                <TechBadge key={skill} label={skill} />
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </MotionSection>
  );
}

export default Expertise;
